/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PartnerCategory from './PartnerCategory';
import { doGetCall } from '../../../config/rest';
import PartnerSupplement from './PartnerSupplement';
import { Link } from 'react-router-dom';
import $ from 'jquery';

class PartnerProducts extends React.Component {
  _is_mounted = false;
  //product_tabsData used to store required product tab title eg. pro, platinum
  // product_withTab & product_nonTab used to filter product based on tab availablity to display in different ui form
  constructor(props) {
    super(props);
    this.state = {
      productsArr : [],
      products: [],
      product_description: [],
      product_tabsData: [],
      product_nonTab: [],
      product_withTab: []
     };
  }

  componentWillMount() {
    // param is used to get product name from url e.g CPA
    const param = this.props.match.params.product && this.props.match.params.product.replace(`${this.props.match.params.partnerId}-`,'').replace(/\-/g,' ').toUpperCase();
    this._is_mounted = true;
    this.props.PartnerDetailPageResponse.partnerType === "multiCategory" && this.props.PartnerDetailPageResponse.examCategory[param] && this.props.PartnerDetailPageResponse.examCategory[param].map((exam, i) =>
      this._is_mounted && this.setState(prevState => ({
        products: [ ...prevState.products , {"id":i,"categoryName": exam.categoryName,"data": exam.products}]
      }),() => this.state.products.map((item,i) => {
        item.data.map(product =>
          doGetCall(`/wp-json/hybris/v1/partners/${this.props.match.params.partnerId}/${product.code}/product`)
            .then((response) => {
              this._is_mounted && !this.state.productsArr.some(item => item.code === product.code) && this.setState({ 
                productsArr: [...this.state.productsArr, {'index':i , 'categoryName': item.categoryName, 'code': product.code , 'images': response.images ,'url': response.url ,'title': product.name ,'variant': response.variant, 'description': response.product_description}],
              })
            })
            .catch((error) => {
              if (error.response) {
                console.log(error.response.data.errors[0]);
                return error;
              }
            })
        )}
      ))
    );
    
    //!this.state.productsArr.some(item => item.code === product.code) used to avoid duplicate entry in productsArr
    this.props.PartnerDetailPageResponse.partnerType === "singleCategory" && this.props.PartnerDetailPageResponse.exams.map((exam, i) =>
    this._is_mounted && this.setState(prevState => ({
      products: [ ...prevState.products , {"id":i,"categoryName": exam.categoryName,"data": exam.products}]
    }), () => this.state.products.map((item,i) =>{
        item.data.map(product =>
         doGetCall(`/wp-json/hybris/v1/partners/${this.props.match.params.partnerId}/${product.code}/product`)
          .then((response) => {
            this._is_mounted && !this.state.productsArr.some(item => item.code === product.code) &&  this.setState({ 
              productsArr: [...this.state.productsArr, {'index':i ,'categoryName': item.categoryName,'code': product.code , 'images': response.images ,'url': response.url ,'title': product.name ,'variant': response.variant, 'description': response.product_description}],
            })
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.data.errors[0]);
              return error;
            }
          })
      )})
      ));
  }

  footerNoteHandler = () => {
    let i = 0;
    $('div[id^="OfferByPrice"]').each(function(){
      if($(this).css("display") === "none" || $(this).is(':empty')){
        i++;
      }
    })
    if(i === $('div[id^="OfferByPrice"]').length){
      $(".citizen-footer-note").css("display","none");
    }
    else{
      $(".citizen-footer-note").css("display","block");
    }
  }

  componentDidMount(){
    setTimeout(() => {
      // only take those tab name which matches in product sku code
        this.state.products.map(item => {
         !item.categoryName.toLowerCase().includes("supplements") && item.data.map(data =>  {
            if (data.code.toLowerCase().includes("_platinum_")){
              this.setState({
                 product_tabsData: [...this.state.product_tabsData, {order: 1,title:"PLATINUM"}],
                 product_withTab: [...this.state.product_withTab, data]
               })
             } else if (data.code.toLowerCase().includes("_pro_")){
               this.setState({
                 product_tabsData: [...this.state.product_tabsData, {order: 2,title:"PRO"}],
                 product_withTab: [...this.state.product_withTab, data]
               })
             } else if (data.code.toLowerCase().includes("_gold_")){
               this.setState({
                 product_tabsData: [...this.state.product_tabsData, {order: 3,title:"GOLD"}],
                 product_withTab: [...this.state.product_withTab, data]
               })
             } else if (data.code.toLowerCase().includes("_essentials_")){
               this.setState({
                 product_tabsData: [...this.state.product_tabsData, {order: 4,title:"ESSENTIALS"}],
                 product_withTab: [...this.state.product_withTab, data]
               })
             }  else if (data.code.toLowerCase().includes("_silver_")){
               this.setState({
                 product_tabsData: [...this.state.product_tabsData, {order: 5,title:"SILVER"}],
                 product_withTab: [...this.state.product_withTab, data]
               })
             } else if (data.code.toLowerCase().includes("_self-study_") || data.code.toLowerCase().includes("_selfstudy_") || data.code.toLowerCase().includes("_self_study_")){
               this.setState({
                 product_tabsData: [...this.state.product_tabsData, {order: 6,title:"SELF-STUDY"}],
                 product_withTab: [...this.state.product_withTab, data]
               })
             } else if (data.code.toLowerCase().includes("_11th hour_") || data.name.toLowerCase().includes("_11thhour_") || data.name.toLowerCase().includes("_11th-hour_") || data.name.toLowerCase().includes("_11th_hour_")){
               this.setState({
                 product_tabsData: [...this.state.product_tabsData, {order: 7,title:"11TH HOUR"}],
                 product_withTab: [...this.state.product_withTab, data]
               })
             } else{
               this.setState({
                 product_nonTab: [...this.state.product_nonTab, data]
               })
             }})
        })
    }, 800);
    setTimeout(() => {this.footerNoteHandler()},3000);
  }

  componentWillUnmount(){
    this._is_mounted = false
  }

  render() {
    return (
      <div className="partner-detail partner-list-container">
        {/* // <!-- back to products starts --> */}
        {this.props.PartnerDetailPageResponse.partnerType === "multiCategory" &&
        <div className="container back-to-product-container">
          <div className="row">
            <div className="col">
              <p className="back-to-product-title">{this.props.match.params.product && this.props.match.params.product.replace(`${this.props.match.params.partnerId}-`,"").replace(/-/g," ").toUpperCase()}</p>
              <p className="back-to-product-link">
                <span className="fa fa-chevron-left" />
                <Link to={this.props.match.url.replace(`/${this.props.match.params.product}`,"").replace(`/${this.props.match.params.partnerProduct}`,"")}>BACK TO ALL PRODUCTS</Link>
              </p>
            </div>
          </div>
        </div>}
        
        {/* <!-- back to products ends --> */}
        {this.state && this.state.productsArr && (this.state.productsArr.length === 0  ? <h1 style={{textAlign: 'center'}}><i className="fa fa-spinner fa-spin"></i></h1> : this.state.productsArr.sort((a, b) => a.categoryName.includes("Supplements") ? 1 : -1).map((block, index) =>
       !block.categoryName.includes("Supplements") ? <PartnerCategory key={index} tabs={this.state.product_tabsData.sort((a,b) => a.order < b.order ? -1 : 1)} nonTabProduct={this.state.product_nonTab} product_withTab={this.state.product_withTab} {...this.props} index={index} productData={this.state.productsArr[index]} partnerId={this.props.match.params.partnerId} />
       : <PartnerSupplement key={index} index={index} productData={this.state.productsArr[index]} partnerId={this.props.match.params.partnerId} />
        ))}
      </div>
    );
  }
}

export default PartnerProducts;
